// TODO: change this to UPPERCASE_SNAKE format.
export const MapAndContact = {
  GettingThere: 'gettingthere',
  WhereTitle: 'where',
  SearchLocationsText: 'Search locations',
  GetDirections: 'getdirections',
  CallUs: 'callus',
  ReceptionHours: 'receptionhours',
  ClosestAirport: 'closestairport',
  ClosestStation: 'closeststation',
  twentyFourAccessTitle: 'TwentyFourAccessTitle',
  twentyFourAccessText: 'TwentyFourAccessText',
};

export const SolutionsInTheAreaKeys = {
  CoworkingDeskLabel: 'coworkingdesklabel',
  LocationsLabel: 'locationslabel',
  OfficesLabel: 'officeslabel',
  OfficesToRentLabel: 'officestorentlabel',
  MeetingRoomLabel: 'meetingroomlabel',
  ViewAllLocationsCTA: 'ViewAllLocationsCTA',
  PopularInThisAreaStickyLabel: 'PopularInThisAreaStickyLabel',
  SolutionsInTheAreaStickyLabel: 'SolutionsInTheAreaStickyLabel',
  SolutionCardsStickyLabel: 'SolutionCardsStickyLabel',
};

export const SolutionCardsKeys = {
  MiscCardsForGeoSolutionTitle: 'misccardforgeosolutiontitle',
  LocationSolutionCardsHeadline: 'LocationSolutionCardsHeadline',
};

export const COMMONS = {
  CLOSE: 'Close',
  FROM: 'From',
  GET_IN_TOUCH: 'GetInTouchCTA',
  MONTHS_24: 'Months24',
  SAVINGS_15: 'Savings15',
  SEE_LESS: 'SeeLessCTA',
  SEE_MORE: 'SeeMoreCTA',
};

export const SOLUTIONS_DICTIONARIES = {
  OFFICE_SPACE: 'GeoSolutionType699AE6F7-F6C1-474B-8329-0D01A6E1F9B4',
  MEETING_ROOM: 'GeoSolutionType3C6D3C45-5FBB-4D6F-9AA0-060E78E90199',
  COWORKING: 'GeoSolutionTypeF6378AB8-C090-461E-955F-AAC7C624C568',
  VIRTUAL_OFFICE: 'GeoSolutionType0CED58BE-0C2C-4BFC-8C85-CBFD0B8C7399',
};

export const FORM_COPY = {
  CHECKBOX_COMMUNICATION_OFFER: 'CommunicationOfferCheckboxAndText',
  CHECKBOX_PRIVACY_POLICY: 'PrivacyPolicyCheckboxAndText',
  CTA_DISCUSS_QUOTE: 'SBFormDiscussYourQuoteCTA',
  CTA_THANK_YOU_CTA: 'SBThankYouTakeMeBackCTA',
  GENERAL_ERROR: 'GeneralError',
  INVALID_EMAIL: 'InvalidEmail',
  INVALID_PHONE: 'InvalidPhone',
  PLACEHOLDER_EMAIL: 'EmailPlaceholder',
  PLACEHOLDER_FULL_NAME: 'FullNamePlaceholder',
  PLACEHOLDER_PHONE_NUMBER: 'PhoneNumberPlaceholder',
  REQUIRED_CHECKBOX: 'RequiredCheckbox',
  REQUIRED_DATE: 'RequiredDate',
  REQUIRED_FIELD: 'RequiredField',
  REQUIRED_OPTION: 'RequiredOption',
};

export const inlineForm = {
  headline: 'InlineHeadline',
  subheadline: 'InlineSubHeadline',
  privacyPolicy: 'PrivacyPolicyCheckboxAndText',
  placeholders: {
    solution: 'SolutionPlaceholder',
    fullName: 'FullNamePlaceholder',
    email: 'EmailPlaceholder',
    phoneNumber: 'PhoneNumberPlaceholder',
    sendMessages: 'CommunicationOfferCheckboxAndText',
  },
  submit: 'InlineFormCTA',
  submitSuccess: 'InlineSuccessCTA',
  successMessage: 'InlineSubmitSuccess',
};

export const RICH_FILTERING = {
  ASSOCIATED_PARTNER: 'AssociatedPartner',
  BRANDS: 'Brands',
  CLEAR: 'Clear',
  FEATURED: 'Featured',
  FILTERS_AND_SORT: 'FiltersAndSort',
  FILTERS: 'Filters',
  FIND_YOUR_SOLUTION: 'FindYourSolution',
  HIDE_MAP: 'HideMap',
  MAX: 'Max',
  MESSAGE_PRICE_PER_HOUR: 'MessagePricePerHour',
  MESSAGE_PRICE_PER_MONTH: 'MessagePricePerMonth',
  MIN: 'Min',
  NO_RESULTS: 'NoResults',
  PLACEHOLDER_TEXT_SEARCH: 'PlaceholderTextSearch',
  PPPH: 'PPPH',
  PPPM: 'PPPM',
  PRICE_RANGE: 'PriceRange',
  REFRESH_MAP: 'RefreshMap',
  SHOW_MAP: 'ShowMap',
  SHOW_RESULTS: 'ShowResults',
  SORT_BY: 'SortBy',
  TO: 'To',
};

export const SOLUTION_BUILDER = {
  ALTERNATIVE_RECOMMENDATION: 'alternativerecommendation',
  BACK: 'SBBackCTA',
  DISCOUNT_TEXT: 'DiscountText',
  DISCUSS_QUOTE_CTA: 'SBResultsDiscussYourQuoteCTA',
  FEATURES_AND_PRICING: 'featuresandpricing',
  MONTHTEXT: 'MonthText',
  NEXT: 'SBNextCTA',
  OF: 'SBof',
  PEOPLE: 'People',
  PRICE_RESULT_COPY: 'PriceResultCopy',
  START_OVER_CTA: 'StartOverCTA',
  STEP: 'SBStep',
  TAB1: 'SidePanelTabText',
  TAB2: 'SidePanelTabText2',
};

export const CURRENCY = {
  COP: 'COP',
};

export const PRICE_UNITS = {
  PPPM_SHORT: 'PPPM_SHORT',
};

export const CTAS = {
  BOOK_A_TOUR_CTA: 'BookAVisitCTA',
  SEE_ALL_LOCATIONS_CTA: 'SeeAllLocation',
};
